/**
 * Copyright (c) 2025, WSO2 LLC. (https://www.wso2.com).
 *
 * WSO2 LLC. licenses this file to you under the Apache License,
 * Version 2.0 (the "License"); you may not use this file except
 * in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing,
 * software distributed under the License is distributed on an
 * "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
 * KIND, either express or implied. See the License for the
 * specific language governing permissions and limitations
 * under the License.
 */

import {I18nBundle, I18nTranslations} from '../models/i18n';
import * as i18n from '../i18n';

/**
 * Get internationalization bundles for the specified locale.
 *
 * @param locale - The locale to get the bundle for (defaults to 'en-US')
 * @returns The i18n bundle for the specified locale
 */
const getI18nBundles = () => {
  return i18n;
};

export default getI18nBundles;
